import { resolveAuditListQueryStatusParam } from "../constants/audit-list-query-status.js";

/**
 * @typedef {Object} AuditSaleReopenListQueryInput
 * @property {number} [page]
 * @property {number} [pageSize]
 * @property {string} [status]
 * @property {number|string} [idsale] — mutuamente exclusivo com `codIntern`
 * @property {string} [codIntern] — mutuamente exclusivo com `idsale`
 * @property {import("../constants/audit-sale-reopen-list-api.js").AuditSaleReopenListOperationParam} [operation]
 * @property {import("../constants/audit-sale-reopen-list-api.js").AuditSaleReopenListPermissionParam} [permission]
 * @property {import("../constants/audit-sale-reopen-list-api.js").AuditSaleReopenListRoleCodeParam} [role_code]
 * @property {boolean} [legacyFallback] — envia params legados (`groupStatusFilter`, `saleIdFilter`) para backends antigos
 * @property {string} [groupStatusFilter] — legado; só com `legacyFallback`
 * @property {number|string} [saleIdFilter] — legado; só com `legacyFallback`
 * @property {number|string} [saleId] — alias interno de `idsale`
 * @property {string} [roleCodeFilter] — alias interno de `role_code`
 * @property {string} [sortBy] — campo de ordenação
 * @property {'ASC'|'DESC'} [sortOrder] — direção da ordenação
 */

/**
 * Serializa params da listagem conforme contrato Swagger.
 * `idsale` e `codIntern` nunca são enviados juntos (`codIntern` tem precedência).
 * @param {AuditSaleReopenListQueryInput} params
 * @returns {URLSearchParams}
 */
export function serializeAuditSaleReopenListQuery(params = {}) {
  const query = new URLSearchParams();

  if (params?.page != null) query.set("page", String(params.page));
  if (params?.pageSize != null) query.set("pageSize", String(params.pageSize));

  if (params?.status) {
    query.set("status", resolveAuditListQueryStatusParam(params.status));
  }

  const codIntern =
    params?.codIntern != null && String(params.codIntern).trim() !== ""
      ? String(params.codIntern).trim()
      : null;

  const idsaleRaw = params?.idsale ?? params?.saleId;
  const idsale =
    idsaleRaw != null && String(idsaleRaw).trim() !== ""
      ? String(idsaleRaw).trim()
      : null;

  if (codIntern) {
    query.set("codIntern", codIntern);
  } else if (idsale) {
    query.set("idsale", idsale);
  }

  if (params?.operation) query.set("operation", String(params.operation));
  if (params?.permission) query.set("permission", String(params.permission));

  const roleCode = params?.role_code ?? params?.roleCodeFilter;
  if (roleCode) query.set("role_code", String(roleCode));

  if (params?.legacyFallback) {
    if (params?.groupStatusFilter) {
      query.set("groupStatusFilter", String(params.groupStatusFilter));
    }
    if (params?.saleIdFilter != null && String(params.saleIdFilter).trim() !== "") {
      query.set("saleIdFilter", String(params.saleIdFilter));
    }
  }

  if (params?.sortBy) {
    query.set("sortBy", String(params.sortBy));
    if (params?.sortOrder) {
      query.set("sortOrder", String(params.sortOrder));
    }
  }

  return query;
}
